/** Anchor of the daily-quests section on the SHOT BAND screen. */
export const BAND_QUESTS_ANCHOR_ID = 'band-quests';

const POLL_INTERVAL_MS = 100;
const GIVE_UP_AFTER_MS = 2_000;

/**
 * Scrolls to the quests section once it exists. Called right after navigating to the club from
 * a notification toast, where the section is several awaits away: the route has to transition
 * (web) and the status + quests queries have to land before anything is mounted — so poll for
 * the node instead of guessing a delay, and give up rather than hang if the user navigates on.
 */
export function scrollToBandQuests(): void {
  if (typeof document === 'undefined') return;

  const deadline = Date.now() + GIVE_UP_AFTER_MS;
  const tick = () => {
    const target = document.getElementById(BAND_QUESTS_ANCHOR_ID);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (Date.now() < deadline) {
      setTimeout(tick, POLL_INTERVAL_MS);
    }
  };
  tick();
}
